var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#E18AFF",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6878 16.3046H15.6462C15.2791 16.3046 14.9815 16.0071 14.9815 15.64C14.9815 15.2729 15.2791 14.9754 15.6462 14.9754H20.6878L18.4993 12.7869C18.2397 12.5273 18.2397 12.1065 18.4993 11.847C18.7588 11.5874 19.1796 11.5874 19.4392 11.847L22.7623 15.17C23.0218 15.4296 23.0218 15.8504 22.7623 16.11L19.4392 19.433C19.1796 19.6926 18.7588 19.6926 18.4993 19.433C18.2397 19.1735 18.2397 18.7527 18.4993 18.4931L20.6878 16.3046ZM19.6338 22.9508V21.6215C19.6338 21.2545 19.9314 20.9569 20.2985 20.9569C20.6655 20.9569 20.9631 21.2545 20.9631 21.6215V23.6154C20.9631 23.9824 20.6655 24.28 20.2985 24.28H9.66462C9.29756 24.28 9 23.9824 9 23.6154V7.66462C9 7.29756 9.29756 7 9.66462 7H20.2985C20.6655 7 20.9631 7.29756 20.9631 7.66462V9.65846C20.9631 10.0255 20.6655 10.3231 20.2985 10.3231C19.9314 10.3231 19.6338 10.0255 19.6338 9.65846V8.32923H10.3292V22.9508H19.6338ZM12.3231 13.6462C12.3231 13.2791 12.6206 12.9815 12.9877 12.9815C13.3547 12.9815 13.6523 13.2791 13.6523 13.6462V17.6338C13.6523 18.0009 13.3547 18.2985 12.9877 18.2985C12.6206 18.2985 12.3231 18.0009 12.3231 17.6338V13.6462Z",
    fill: "#FFA3DA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/LogOut.9c2b194d817d27c8f73b9d38c6253f10.svg";
export { ForwardRef as ReactComponent };